<template>
    <div class="guide">
        <m_header/>
        <div class="content" @click="hideList()">
          <div class="title">
            <span class="left">使用指南</span>
            <span class="right">
              <span class="active" @click.stop="toggleList()">
                  {{activeTopic.name}}
                  <span class="triangle">
                  </span>
              </span>
              <transition name="fromLeftTransition">
                  <div class="itemCon" v-if="topicListShow">
                    <div v-for="item in topicList" :key="item.id" class="item" :class="{'active':activeTopic.id == item.id}" @click="changeTopic(item)">
                      {{ item.name }}
                    </div>
                  </div>
              </transition>
            </span>
          </div>
          <div class="questionList">
            <div v-for="item in questionList" :key="item.id" class="item" @click="toArticle(item.id)">
                {{ item.question }}
            </div>
          </div>
          <div class="toolCon">
            <div class="title">
                自助工具
            </div>
            <div class="verify">
                <a href="https://mooc-stage.chinesecio.com/verify/" target="_blank">检测设备</a>
            </div>
          </div>
        </div>
        <m_footer/>
    </div>
</template>

<script>
import m_header from './m_header'
import m_footer from './m_footer'
import {mapState} from 'vuex'
export default {
    name: 'm_guide',
    components: {
      m_header,
      m_footer
    },
    computed: {
      ...mapState({
          username: state => state.username,   //使用ES6的箭头函数来给count赋值
          email: state => state.email, 
      })
    },
    data: function () {
        return {
            topicListShow: false,
            topicList: [], // 栏目列表
            questionList: [], // 问题列表
            questionInfo: '', // 问题详情
            activeTopic: {
                id: 1,
                name: '热门问题'
            },
            activeQuestion: undefined
        }
    },
    methods: {
        // 问题详情
        toArticle(item) {
            this.activeQuestion = item
            this.$router.push({
              path: 'm_guidedetail',
              query: {
                question_id: this.activeQuestion
              }
            })
        },
        // 问题列表
        getQuestionList(id) {
            this.$utils.get('/help/question/getlist', {
                topic_id: id,
                limit: 999
            }).then(res => {
                if(res.data.success) {
                    this.questionList = res.data.data.list
                }
            })
        },
        // 栏目列表
        getTopicList() {
            this.$utils.get('/help/topic/getlist', {
                limit: 100
            }).then(res => {
                if(res.data.success) {
                    this.topicList = res.data.data.list
                    this.getQuestionList(this.topicList[0].id)
                    this.activeTopic = this.topicList[0]
                }
            })
        },
        changeTopic(item) {
            this.activeTopic = item
            this.activeQuestion = undefined
            this.questionInfo = undefined
            this.getQuestionList(item.id)
        },
        toggleList() {
          this.topicListShow = !this.topicListShow
        },
        hideList() {
          this.topicListShow = false
        },
        // doSomething(){
        //   this.$store.commit('setUser','haoxin', '249446833@qq.com');
        // }	
    },
    mounted() {
        this.getTopicList()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.guide {
  height: 100%;
  position: relative;
  background-color: #fff;
  .content {
    min-height: calc(100% - 3.3rem);
    .title {
      height: 1.06rem;
      line-height: 1.06rem;
      border-bottom: 0.1rem solid #d6e1e5;
      .left {
        font-size: 0.36rem;
        font-weight: bold;
        color: #364347;
        margin-left: 0.28rem;
      }
      .right {
        float: right;
        .active {
          font-size: 0.4rem;
          padding-left: 0.2rem;
          .triangle {
            position: relative;
            top: -2px;
            display: inline-block;
            margin-left: 3px;
            margin-right: 0.28rem;
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 7px solid #364347;
          }
        }
        .itemCon {
          position: absolute;
          right: 0;
          width: 153px;
          max-height: calc(100% - 2.06rem);
          overflow-y: auto;
          padding-bottom: 20px;
          box-sizing: border-box;
          background-color: #fff;
          box-shadow: 0 4px 7px 0 rgba(0,0,0,0.3);
          .item {
            float: initial;
            margin-left: 22px;
            border-bottom: 1px solid #b2c6cd;
            font-size: 14px;
            color: #364347;
            font-weight: bold;
          }
          .active {
            padding-left: 0;
          }
        }
        /* 设置持续时间和动画函数 */
        .fromLeftTransition-enter-active {
          transition: all .3s ease;
        }
        .fromLeftTransition-leave-active {
          transition: all .3s ease;
        }
        .fromLeftTransition-enter, .fromLeftTransition-leave-to {
          transform: translateX(153px);
          opacity: 0;
        }
      }
    }
    .questionList {
      width: 100%;
      height: 8rem;
      .item {
        font-size: 0.3rem;
        line-height: 1.2;
        margin-left: 0.3rem;
        padding: 0.3rem 0.3rem 0.3rem 0;
        box-sizing: border-box;
        border-bottom: 1px solid #b2c6cd;
      }
    }
    .toolCon {
        margin-top: 0.5rem;
        border-top: 5px solid #d6e1e5;
        padding-bottom: 40px;
        .title {
            font-size: 0.34rem;
            border: none;
            font-weight: bold;
            margin-left: 0.3rem;
        }
        .verify {
            width: 2.12rem;
            height: 0.72rem;
            font-size: 0.32rem;
            line-height: 0.72rem;
            margin-left: 0.3rem;
            margin-top: 0.2rem;
            background-color: #fff;
            border: 1px solid #1da1cd;
            text-align: center;
            color: #1da1cd;
            cursor: pointer;
            a {
                display: inline-block;
                width: 100%;height: 100%;
                text-decoration: none;
            }
            a:visited,a:hover,a:active {
                color: #1da1cd;
            }
        }
        .verify:hover {
            background-color: #1da1cd;
            color: #fff;
            a {
                color: #fff;
            }
        }
    }
  }
}
</style>
